import type { ComponentType } from 'react'
import { KIND } from 'baseui/button'
import BaseSDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import BaseSDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import IconSearch from '@/shared/icons/NewDesign/IconSearch'
import { DashboardV2Filters } from '../../types'
import useSearchCard from './useSearchCard'
import { OverviewCard, SearchForm, SearchGrid } from '../styled-components'

const SDButton = BaseSDButton as ComponentType<any>
const SDInput = BaseSDInput as ComponentType<any>

interface SearchCardProps {
  filters: DashboardV2Filters
  applicationType: string
}

const SearchCard = ({ filters, applicationType }: SearchCardProps) => {
  const { title, fields, submitLabel, submitOverrides, onSubmit } = useSearchCard({ filters, applicationType })

  return (
    <OverviewCard aria-label={title}>
      <SearchForm role='search' onSubmit={onSubmit}>
        <SearchGrid>
          {fields.map(field => (
            <SDInput
              key={field.key}
              name={field.key}
              label={field.label}
              aria-label={field.label}
              currentValue={field.value}
            />
          ))}
        </SearchGrid>
        <SDButton type='submit' kind={KIND.primary} overrides={submitOverrides} startEnhancer={<IconSearch />}>
          {submitLabel}
        </SDButton>
      </SearchForm>
    </OverviewCard>
  )
}

export default SearchCard
